// Textes d'origine de chaque rubrique de la landing, affichés dans l'éditeur Admin (valeur par défaut des champs vides).
// Copie des textes de repli de LandingPage.js : sectionDefaults.test.js vérifie qu'ils restent identiques à ce que la
// landing affiche sans personnalisation (toute divergence fait échouer le test).

export const SECTION_DEFAULTS = {
    "hero": {
        "eyebrow": "Notre réseau d'échange, de propositions et d'alertes",
        "badge_text": "Anonyme par défaut — votre hiérarchie ne voit jamais votre nom",
        "lede": "Un espace pour dire ce qui ne va pas, suivre l'ambiance collective et peser, ensemble, sur les dossiers traités en CSA, Groupe de travail, FSSSCT, CAP et CCP — avant que les décisions ne soient prises sans vous.",
        "primary_label": "S'inscrire — c'est gratuit",
        "secondary_label": "Comment ça marche",
        "trust_line": "Porté par vos représentants du personnel élus — indépendant de toute hiérarchie.",
        "phone_title": "Dernières actualités",
        "title": "Votre voix compte {Faites-la entendre} — anonymement"
    },
    "video": {
        "intro_series": "Les 3 épisodes de notre série, à la suite.",
        "intro": "Le premier épisode de notre série — pour comprendre le réseau en quelques minutes.",
        "collapse_label": "← Revenir à l'épisode 1",
        "expand_label": "Voir toute la série →",
        "title": "Découvrez Paroles d'Agents {en vidéo}",
        "video_id": "JmGWfeloX_Y",
        "playlist_id": "PLKbq7ecqHWJ8"
    },
    "services": {
        "eyebrow": "Comment ça marche",
        "intro": "Sept outils simples, pensés pour votre anonymat, disponibles dès votre inscription — voici comment vous en servir.",
        "title": "Voici les services {auxquels vous allez accéder}",
        "items": [
            {
                "emoji": "🔒",
                "title": "Inscription anonyme",
                "text": "Votre email professionnel sert uniquement à vérifier votre appartenance aux services du Premier Ministre (SPM) et à interdire toute inscription étrangère au ministère — puis vous choisissez un pseudonyme parmi ceux que l'on vous propose (animal + adjectif), que personne ne peut relier à votre nom."
            },
            {
                "emoji": "😊",
                "title": "Humeur du jour",
                "text": "Un tap chaque jour pour dire comment vous allez. Vos représentants suivent l'ambiance collective, jamais votre humeur individuelle."
            },
            {
                "emoji": "🗳️",
                "title": "Sondages",
                "text": "Votre collectif vous consulte sur les sujets en cours. Vous votez en un clic ; les résultats ne s'affichent qu'au-delà d'un seuil de participants, jamais un vote isolé identifiable."
            },
            {
                "emoji": "💡",
                "title": "Idées",
                "text": "Proposez un changement avec l'amorce « Et si chez nous on… ». Vous choisissez votre niveau de visibilité, et vos collègues peuvent soutenir, partager et commenter votre proposition."
            },
            {
                "emoji": "💬",
                "title": "Discussions",
                "text": "Rejoignez un fil par sujet ou par service pour échanger avec vos collègues, sous votre pseudonyme."
            },
            {
                "emoji": "🤝",
                "title": "Invitez un collègue",
                "text": "Générez un lien depuis l'app et partagez-le par email ou message. Aucune donnée personnelle n'est requise pour vous inscrire."
            },
            {
                "emoji": "🛟",
                "title": "Demande d'aide",
                "text": "Un canal confidentiel direct avec un représentant du personnel, pour les situations difficiles — harcèlement, mal-être, conflit. Toujours sous votre pseudonyme."
            }
        ]
    },
    "signup": {
        "eyebrow": "Plus nous sommes nombreux, plus notre voix porte",
        "lede": "Un dossier porté par 50 voix pèse plus qu'un dossier porté par une seule. Chaque agent qui rejoint Paroles d'Agents renforce ce que vos représentants peuvent obtenir en instance.",
        "invite_text": "Partagez le lien à un collègue — aucune donnée personnelle requise.",
        "button_label": "Accéder au réseau",
        "tuto_title": "Inscription pas à pas",
        "title": "Inscrivez-vous, {invitez} un.e collègue",
        "steps": [
            {
                "text": "Cliquez sur **« Accéder au réseau »** en haut de cette page"
            },
            {
                "text": "Choisissez **« Créer un compte »** et entrez votre adresse email professionnelle — elle sert uniquement à vérifier que vous appartenez aux services"
            },
            {
                "text": "L'appli vous propose **trois pseudonymes** composés d'un animal et d'un adjectif — choisissez celui qui vous plaît. Ce pseudo protège votre anonymat : personne ne peut faire le lien avec votre vrai nom"
            },
            {
                "text": "Créez votre mot de passe — et c'est tout. Vous êtes dans le réseau"
            }
        ],
        "tuto_video_id": "T-RHLnszgus"
    },
    "testimonials": {
        "disclaimer": "Exemples fictifs présentés à titre d'illustration.",
        "items": [
            {
                "quote": "J'ai enfin pu dire ce qui ne va pas sans craindre les conséquences.",
                "pseudo": "Renard prudent",
                "service": "SPM"
            },
            {
                "quote": "Mes représentants ont porté mon problème en CSA. Je n'aurais jamais osé seul.",
                "pseudo": "Hibou curieux",
                "service": "DILA"
            },
            {
                "quote": "L'humeur du jour m'a montré que je n'étais pas le seul à trouver ça difficile.",
                "pseudo": "Castor serein",
                "service": "INSP"
            }
        ]
    },
    "threads": {
        "eyebrow": "Avant que la décision ne tombe",
        "intro": "Chaque dossier en cours d'instruction a son fil. Vos réactions deviennent la matière que vos représentants portent en instance.",
        "title": "Donnez votre avis, {pas} seulement vos représentants"
    },
    "wellbeing": {
        "eyebrow": "Ressources bien-être",
        "intro": "Des outils validés pour mettre des mots sur ce que vous ressentez au travail — anonymes et sans inscription.",
        "title": "Évaluez, {comprenez}, agissez",
        "items": [
            {
                "emoji": "📋",
                "title": "Travaillez-vous dans une maison de fous ?",
                "subtitle": "Test QVT de Martin Wehle",
                "meta": "40 questions · 5 minutes",
                "description": "Évaluez objectivement la qualité de vie au travail dans votre service grâce à un outil reconnu.",
                "button_label": "Faire le test",
                "path": "/qvt"
            },
            {
                "emoji": "🧠",
                "title": "Évaluez votre santé mentale",
                "subtitle": "Questionnaire GHQ-12",
                "meta": "12 questions · 3 minutes · Anonyme",
                "description": "Un outil clinique validé pour mesurer l'impact du travail sur votre bien-être psychologique.",
                "button_label": "Commencer le test",
                "path": "/ghq12"
            },
            {
                "emoji": "🤖",
                "title": "IA et agents : où en êtes-vous, humainement parlant ?",
                "subtitle": "Parcours adaptatif",
                "meta": "15 questions · 6 minutes · Anonyme",
                "description": "Un parcours qui s'adapte à vos réponses, de la découverte de l'IA aux enjeux de cyberdéfense.",
                "button_label": "Commencer le parcours",
                "path": "/ia-agents"
            }
        ]
    },
    "mood": {
        "eyebrow": "Mesure collective & anonyme",
        "intro": "Un indicateur d'alerte précoce pour vos représentants — jamais un outil de surveillance individuelle.",
        "card_title": "Climat de travail, tous services",
        "card_text": "Calculé à partir des réponses anonymisées au pouls quotidien. Sert à documenter une alerte FSSSCT ou un point d'ordre du jour en CSA.",
        "title": "L'ambiance, {vue} d'ensemble"
    },
    "syndicat": {
        "eyebrow": "Qui porte Paroles d'Agents",
        "title": "Un syndicat {autonome}, élu par vous",
        "paragraphs": [
            {
                "text": "Le SAPPM (Syndicat Autonome des Personnels des Services du Premier Ministre) est l'organisation qui porte ce réseau — des agents élus par leurs collègues, pas une direction, pas une structure RH."
            },
            {
                "text": "Cette indépendance est ce qui rend la confidentialité crédible : ce que vous partagez sert votre défense collective, jamais l'évaluation de votre hiérarchie."
            },
            {
                "text": "Pour les situations les plus difficiles — harcèlement, mal-être, conflit — un canal confidentiel dédié vous met directement en lien avec un représentant, sous votre pseudonyme anonyme."
            }
        ],
        "badges": [
            {
                "text": "SPM · DILA · INSP · SGDSN"
            },
            {
                "text": "Élections décembre 2026"
            }
        ],
        "poster_url": "/sappm-syndicat-poster.jpg"
    }
};
